import { render, staticRenderFns } from "./AboutHeader.vue?vue&type=template&id=2e3166f9&"
import script from "./AboutHeader.vue?vue&type=script&lang=js&"
export * from "./AboutHeader.vue?vue&type=script&lang=js&"
import style0 from "./AboutHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports